import { useLocation } from 'react-router-dom';
import { resolveLoaderMessage } from '../../config/loader.config';
import TropaymentLoader from './TropaymentLoader';

export default function RouteFallback() {
  const { pathname } = useLocation();
  return <TropaymentLoader variant="inline" message={resolveLoaderMessage(pathname)} />;
}
